import React from 'react';
import { CheckOutline } from 'antd-mobile-icons';
import {t} from "../../../../i18n";

interface PickUpUploadNotificationProps {
    status: 'retrying' | 'success' | 'none';
    onClick: () => void;
}

const PickUpUploadNotification: React.FC<PickUpUploadNotificationProps> = ({ status, onClick }) => {
    if (status === 'none') return null;

    const isRetrying = status === 'retrying';
    const bgColor = isRetrying ? 'bg-pink-100' : 'bg-green-100';
    const message = isRetrying
        ? t(`pages.pickUp.failed.failedRetry`)
        : t(`pages.pickUp.failed.failedRetrySuccess`)
    const icon = isRetrying ? (
        <div className="animate-spin h-5 w-5 border-2 border-pink-700 rounded-full border-t-transparent" />
    ) : (
        <span className="text-green-700">
            <CheckOutline />
        </span>
    );

    return (
        <div
            className={`flex justify-between items-center px-4 py-2 ${bgColor} mb-2`}
            onClick={onClick}
        >
            <span>{message}</span>
            {icon}
        </div>
    );
};

export default PickUpUploadNotification;
